import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './AppTooltip.scss';

const AppTooltip = ({
  title,
  children,
  placement = 'top',
  arrow = true,
  className = '',
  triggerClassName = '',
  ariaLabel = 'More information',
}) => {
  const trigger =
    children ??
    (
      <button
        type='button'
        className={`app-tooltip__info-trigger ${triggerClassName}`.trim()}
        aria-label={ariaLabel}
      >
        <InfoOutlinedIcon className='app-tooltip__info-icon' />
      </button>
    );

  return (
    <Tooltip
      title={title}
      arrow={arrow}
      placement={placement}
      enterTouchDelay={0}
      slotProps={{
        tooltip: { className: 'app-tooltip__content' },
        arrow: { className: 'app-tooltip__arrow' },
      }}
    >
      <span className={`app-tooltip__anchor ${className}`.trim()} tabIndex={0}>
        {trigger}
      </span>
    </Tooltip>
  );
};

export default AppTooltip;
